export const getCountryCodeForCountry = (countryName) => {
  if (!countryName) return '';
  const c = countryName.toLowerCase().trim();
  switch (c) {
    case 'india': return '+91';
    case 'united states':
    case 'usa':
    // case 'canada': return '+1';
    case 'united kingdom':
    case 'uk': return '+44';
    case 'australia': return '+61';
    // add more mappings as needed
    default: return '';
  }
};